import ReactApexChart from 'react-apexcharts';
import { withTranslation } from 'react-i18next';

import { convertCents, formatCurrency } from '../../../../helpers/format';
import chartLocales from '../../utils/locales';

const DiscountsChart = ({ data, t }): React.JSX.Element => {
  const indicators = data?.billing?.data;

  return (
    <ReactApexChart
      type="line"
      height={550}
      options={{
        chart: {
          stacked: true,
          toolbar: { show: false },
          ...chartLocales,
        },

        title: {
          align: 'center',
          text: t('reports.discount.title'),
        },

        subtitle: {
          align: 'center',
          text: t('reports.discount.subtitle'),
        },

        legend: {
          onItemHover: { highlightDataSeries: true },
          onItemClick: { toggleDataSeries: true },
        },

        markers: { size: 5 },
        stroke: { width: [1, 1, 1, 2] },
        colors: ['#1b73e8', '#aaff03', '#ff6400', '#ec616c'],
        labels: indicators?.map((i) => i?.created_at),

        xaxis: {
          labels: {
            formatter: (v) => new Date(v).toLocaleDateString('pt-BR'),
          },
        },

        yaxis: {
          labels: {
            formatter: (v) => formatCurrency(v, { style: 'percent' }),
          },
        },
      }}
      series={[
        {
          name: t('reports.discount.chart.discount'),
          data: indicators?.map((i) =>
            formatCurrency(i?.discount, { style: 'percent' })
          ),
        },

        {
          name: t('reports.discount.chart.discount-percentage'),
          data: indicators?.map((i) =>
            convertCents(i?.redeem_billing_incremental_percentage)
          ),
        },
      ]}
    />
  );
};

export default withTranslation()(DiscountsChart);
